import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from '../../services/payment.service';
import { MatDialog } from '@angular/material/dialog';
import { PaymentResponse } from '../../models/payment-response';
import { HttpErrorResponse } from '@angular/common/http';
import { ModalComponent } from '../modal/modal.component';
import { PatternDialogComponent } from '../pattern-dialog/pattern-dialog.component';
import { ModalConfirmService } from '../../services/modal-confirm.service';

@Component({
  selector: 'app-payment',
  standalone: true,
  imports: [],
  templateUrl: './payment.component.html',
  styleUrl: './payment.component.scss',
})
export class PaymentComponent implements OnInit {
  imageSrc: any;
  orderId: string;
  paymentData: PaymentResponse;

  constructor(
    private route: ActivatedRoute,
    private paymentService: PaymentService,
    private modalConfirm: ModalConfirmService
  ) {}

  ngOnInit(): void {
    // tempo code
    // this.orderId = '123';
    // this.paymentData = {
    //   uuid: '19e7b7c5-c88e-7ab7-8104-80e300e61a5c',
    //   orderNumber: '19e7b7c5-c88e-7ab7-8104-80e300e61a5c',
    //   paymentState: 'DEPOSITED',
    //   amount: 35000,
    //   currency: '933',
    //   date: new Date('2025-07-10T09:29:25.524+00:00'),
    // };
    // console.log(this.paymentData);
    // this.openDialog();
    // end tempo code

    this.route.queryParams.subscribe((params) => {
      this.orderId = params['orderId'];
      if (this.orderId) {
        this.paymentService.sendPaymentResponse(this.orderId).subscribe(
          (response: PaymentResponse) => {
            this.paymentData = response;
            this.openDialog();
          },
          (error: HttpErrorResponse) => {
            // this.paymentData = error.message;
            this.openDialog();
          }
        );
      }
    });
  }

  openDialog() {
    if (this.paymentData.paymentState === 'DEPOSITED') {
      this.modalConfirm.open({
        mode: 'success',
        functionality: false,
        title: 'Оплата успешно завершена!',
        description:
          'Мы свяжемся с вами в течение 24 часов, чтобы согласовать оставшиеся шаги. Спасибо за доверие.',
        returnFunctionality: true,
      });
    } else {
      this.modalConfirm.open({
        mode: 'warning',
        functionality: false,
        title: 'Что-то пошло не так',
        description:
          'К сожалению, платёж не был завершён. Проверьте данные карты и повторите попытку.',
        returnFunctionality: true,
      });
    }
  }
}
